<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2xkA53/tc-custom/9781455626915.jpg?1673608908721" alt="This image is the cover for the book Craft"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Craft
      </h1>
      <p class="bookDescription body article font2">
        <p>The clink of ice, the fragrance of fresh herbs, and the ritual of pouring artisanal spirits into a shaker or glass are all integral to the timeless experience of crafting a sophisticated cocktail. <br/><br/>When we aren't drinking, whatever the reason may be, we still want to enjoy elegant, thoughtful beverages. This philosophy is at the heart of Craft: The Eat Fit Guide to Zero Proof Cocktails.<br/><br/>Inspired by the talented bar staff of dozens of Eat Fit restaurant partners, these zero proof recipes surpass sugary mocktails and basic soda spritzers, proving that it's truly possible to create remarkable, elevated drinks that are alcohol free with little or no added sugars. <br/><br/>Featuring more than 50 recipes, as well as guides to barware, bitters, glassware, and everything else you need to craft a fully sensorial cocktail, this book is an essential--and beautiful--resource for every home mixologist's library.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Molly Kimball, RD, CSSD with Ethan Skaggs, Edited by Melanie Warner Spencer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fbdf6a7a